export default "__VITE_ASSET__BD_kNOW7__"